import { render, staticRenderFns } from "./convertor.vue?vue&type=template&id=240b8b6f&"
import script from "./convertor.vue?vue&type=script&lang=js&"
export * from "./convertor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailConverter: require('/src/components/detail/mobile/detail_converter.vue').default})
